import { useMemo } from 'react'

import { Box } from '@chakra-ui/react'

import { TailgateBox } from '../../types/types'

interface GridOverlayIProps {
  inBox: TailgateBox
  outBox: TailgateBox
}

const getPolygonPoints = (box: TailgateBox): string =>
  box.corners.map((c) => `${c.x},${c.y}`).join(' ')

const getCentroid = (box: TailgateBox) => {
  const sumX = box.corners.reduce((acc, c) => acc + c.x, 0)
  const sumY = box.corners.reduce((acc, c) => acc + c.y, 0)
  return { x: sumX / box.corners.length, y: sumY / box.corners.length }
}

export const GridOverlay = ({ inBox, outBox }: GridOverlayIProps) => {
  const inPolygonPoints = useMemo(() => getPolygonPoints(inBox), [inBox])
  const inCentroid = useMemo(() => getCentroid(inBox), [inBox])
  const outPolygonPoints = useMemo(() => getPolygonPoints(outBox), [outBox])
  const outCentroid = useMemo(() => getCentroid(outBox), [outBox])

  return (
    <Box
      h='100%'
      left={0}
      pointerEvents='none'
      position='absolute'
      top={0}
      w='100%'
      zIndex={1}
    >
      <svg
        height='100%'
        style={{ position: 'absolute', top: 0, left: 0 }}
        width='100%'
      >
        {inBox.isValid && (
          <>
            <polygon
              fill='rgba(72, 187, 120, 0.25)'
              points={inPolygonPoints}
              stroke='rgba(72, 187, 120, 0.8)'
              strokeWidth='2'
            />
            <text
              fill='rgba(72, 187, 120, 0.9)'
              fontSize='14'
              fontWeight='bold'
              textAnchor='middle'
              x={inCentroid.x}
              y={inCentroid.y}
            >
              IN
            </text>
          </>
        )}
        {outBox.isValid && (
          <>
            <polygon
              fill='rgba(245, 101, 101, 0.25)'
              points={outPolygonPoints}
              stroke='rgba(245, 101, 101, 0.8)'
              strokeWidth='2'
            />
            <text
              fill='rgba(245, 101, 101, 0.9)'
              fontSize='14'
              fontWeight='bold'
              textAnchor='middle'
              x={outCentroid.x}
              y={outCentroid.y}
            >
              OUT
            </text>
          </>
        )}
      </svg>
    </Box>
  )
}
